// extracted by mini-css-extract-plugin
export var emptyState = "_73-d";
export var statCard = "_73-c";
export var table = "_73-0";
export var tableCell = "_73-4";
export var tableCellClickable = "_73-5 _73-4";
export var tableCellDefault = "_73-6 _73-4";
export var tableCellEmpty = "_73-8";
export var tableCellWithValue = "_73-7";
export var tableContainer = "_73-e";
export var tableHeaderWeight = "_73-1";
export var tableHeaderZone = "_73-2";
export var tableRowHeader = "_73-3";
export var viewModeButton = "_73-9";
export var viewModeButtonActive = "_73-a _73-9";
export var viewModeButtonInactive = "_73-b _73-9";